// extracted by mini-css-extract-plugin
module.exports = {"rotateAnimation":"animations_rotateAnimation__gljbA","rotate":"animations_rotate__2EPre"};